"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { useHeaderImage } from "./use-headerimage-eon";
export function HeaderImageJobboard() {
  const $ = _c(7);
  const {
    largeImageSrc,
    smallImageSrc,
    showHeaderImage
  } = useHeaderImage();
  if (!showHeaderImage) {
    return null;
  }
  let t0;
  if ($[0] !== smallImageSrc) {
    t0 = <CustomImage alt="E.ON Jobboard Header" className="h-full w-full object-cover transition-opacity duration-200 md:hidden" fetchPriority="high" height={1080} priority={true} sizes="100vw" src={smallImageSrc} width={1920} />;
    $[0] = smallImageSrc;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== largeImageSrc) {
    t1 = <CustomImage alt="E.ON Jobboard Header" className="hidden h-full w-full object-cover transition-opacity duration-200 md:block" height={1536} sizes="100vw" src={largeImageSrc} width={4000} />;
    $[2] = largeImageSrc;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="flex aspect-[4/3] min-h-full w-full justify-center md:aspect-2300/850 lg:aspect-3000/850 xl:aspect-3670/850">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}